document.addEventListener('DOMContentLoaded', function () {

  const coSel  = document.getElementById('jwb-company');
  const coPrev = document.getElementById('jwb-company-preview');
  const coImg  = document.getElementById('jwb-company-img');
  const coName = document.getElementById('jwb-company-name');
  const coErr  = document.getElementById('jwb-company-error');

  if (!coSel) return;

  // Get the correct product form (not the installment/payment form)
  function getProductForm() {
    return document.querySelector('form[id^="product-form-"]:not([id*="installment"])');
  }

  // Inject or update hidden input in the correct form
  function injectOrUpdateHidden(value) {
    const form = getProductForm();
    if (!form) { console.warn('JWB: product form not found'); return; }

    let hidden = form.querySelector('input[name="properties[Company]"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[Company]';
      form.appendChild(hidden);
    }
    hidden.value = value;
    console.log('JWB: injected Company =', value, 'into form', form.id);
  }

  // Update logo preview on change
  coSel.addEventListener('change', function () {
    const opt  = coSel.options[coSel.selectedIndex];
    const logo = opt.getAttribute('data-logo');
    const name = opt.value;

    if (coErr) coErr.style.display = 'none';

    if (name && logo) {
      coImg.src            = logo;
      coImg.alt            = name;
      coName.textContent   = name;
      coPrev.style.display = 'flex';
    } else {
      coPrev.style.display = 'none';
    }

    injectOrUpdateHidden(name);
  });

  // Validate + inject on form submit
  const form = getProductForm();
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!coSel.value) {
        if (coErr) coErr.style.display = 'block';
        coSel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        e.preventDefault();
        return;
      }
      injectOrUpdateHidden(coSel.value);
    });
  }

  // Intercept Dawn's fetch-based Add to Cart button (capture phase)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="add"]');
    if (!btn) return;
    const parentForm = btn.closest('form[id^="product-form-"]:not([id*="installment"])');
    if (!parentForm) return;

    if (!coSel.value) {
      if (coErr) coErr.style.display = 'block';
      coSel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    injectOrUpdateHidden(coSel.value);
  }, true);

});